export default "__VITE_ASSET__Bgv_fNRO__"